import { WidgetEnvironment } from './types/moonpayCoreSdkConfig';

export const dimensions = {
  iframe: {
    recommended: {
      height: 640,
      width: 480,
    },
    height: 700,
    width: 768,
  },
};

export const moonpayOrigins: Record<
  WidgetEnvironment,
  Record<string, string>
> = {
  sandbox: {
    buy: 'https://buy-sandbox.moonpay.com',
    sell: 'https://sell-sandbox.moonpay.com',
  },
  production: {
    buy: 'https://buy.moonpay.com',
    sell: 'https://sell.moonpay.com',
  },
};
